
import { Component, Vue, Prop } from "vue-property-decorator";
import { PostJibing } from "@/request/common";
@Component({})
export default class Name extends Vue {
  @Prop()
  private data: any;
  @Prop()
  private ifCompose: any;
  private shifou: any = ["是", "否"];
  private zhiliao: any = [
    "未治疗",
    "间断治疗",
    "坚持治疗",
    "手术治疗",
    "物理康复治疗",
  ];
  private jibingzhuangui: any = ["治愈", "好转", "稳定", "恶化", "不清楚"];
  private jibing: any = [];
  private get c() {
    const arr = this.data;
    // if (!arr.value || arr.value.length === 0) {
    //   const obj = {
    //     疾病: "",
    //     是否患病: "",
    //     确诊时间: "",
    //     治疗情况: "",
    //     服用药物: "",
    //     疾病转归: "",
    //     是否为主要困扰您健康的疾病: "",
    //   };
    //   arr.value = [obj];
    // }
    return arr;
  }
  private radioClick(ev: any, index: any, type: any) {
    if (!this.ifCompose) {
      return;
    }
    this.c.value[index][type] === ev
      ? (this.c.value[index][type] = "")
      : (this.c.value[index][type] = ev);
    this.$emit("update", this.c);
  }
  private addOne() {
    const obj = {
      疾病: "",
      是否患病: "",
      确诊时间: "",
      治疗情况: "",
      服用药物: "",
      疾病转归: "",
      是否为主要困扰您健康的疾病: "",
    };
    this.c.value.push(obj);
    this.$forceUpdate();
  }
  private delOne(index: any) {
    this.c.value.splice(index, 1);
  }
  private mounted() {
    const params = {
      类别: this.c.title,
    };
    PostJibing(this, params).then((res: any) => {
      this.jibing = res;
    });
  }
}
